import {withCustomization} from 'providers/Customization';

const MenuBottom = () => {
  return <div />;
};

export default withCustomization(MenuBottom, 'menuBottom');
